<div class="navigation-row" #navigationRow [ngClass]="{'with-save-offer-button': isAppAgentOrTravelAgency && (currentStep$ | async) === 6}">
  <button *ngIf="isAppAgentOrTravelAgency && (currentStep$ | async) === 6" nxButton="secondary" type="button" class="navigation-button save-offer-button" [disabled]="disableButton$ | async" (click)="saveOfferCalculation()">
    {{ 'navigation.save-offer-button' | translate }}
  </button>
  <div class="navigation-price" *ngIf="offerValue && processOfferVisible">
    <p nxCopytext="normal" class="nx-margin-right-xs">
      {{ 'navigation.offer_price' | translate }}
    </p>
    <h3 nxHeadline="subsection-large" class="navigation-price__price-element">
      <b class="notranslate">
        {{ offerValue || 0 | aztCurrency : 'PLN' }}
      </b>
    </h3>
  </div>
  <button nxButton
          type="button"
          class="navigation-button"
          (click)="goToNextStep()"
          [disabled]="isAnyStatusPending$ | async">
    {{ buttonLabel || 'common.next.generic' | translate }}
  </button>
</div>
